import { css } from '@emotion/css';

export const fieldGroupCx = css`
  label {
    font-weight: 600;
  }
`;

export const applicationCameraCx = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  > :not(:first-child) {
    margin-left: 0.5rem;
  }

  .image-wrapper {
    cursor: pointer;
    display: flex;
    width: 21.875rem;
    height: 14.375rem;

    &.preview > img {
      object-fit: cover;
    }

    &.readonly {
      cursor: default;
      pointer-events: none;
      user-select: none;
    }

    img {
      border-radius: 0.625rem;
      width: 100%;
      height: 100%;
    }
  }
`;
